import { render, staticRenderFns } from "./monitorcar.vue?vue&type=template&id=6807560f&scoped=true"
import script from "./monitorcar.vue?vue&type=script&lang=js"
export * from "./monitorcar.vue?vue&type=script&lang=js"
import style0 from "./monitorcar.vue?vue&type=style&index=0&id=6807560f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807560f",
  null
  
)

export default component.exports